function waitForShopifyForm() {
  const requiredFieldsLabel = document.documentElement.dataset.formRequiredFieldsLabel || '* Campos Obligatorios';
  const addFileLabel = document.documentElement.dataset.formAddFileLabel || 'Añadir archivo';
  const interval = setInterval(() => {
    const forms = document.querySelectorAll("shopify-forms-embed");

    forms.forEach((form) => {
      if (form && form.shadowRoot) {
        clearInterval(interval);

        if (form.shadowRoot.querySelector("#custom-shopify-style")) return;
        const style = document.createElement("style");
        style.id = "custom-shopify-style";
        style.textContent = `
          #app-embed *,
          #form-container-ref *{
              font-family: var(--font-body--family)!important;
          }
          #form-container-ref *{
              font-style: var(--font-body--style)!important;
              font-weight: var(--font-body--weight)!important;
              font-size: var(--font-size--paragraph)!important;
              box-sizing: border-box!important;
          }
          #form-container-ref form > div:first-child{
              display:none!important;
          }
          #form-container-ref form{
              // display: grid!important;
              // grid-template-columns: 1fr 1fr!important;
              padding-top: 1px !important;
          }

          [data-testid="banner-success"] * {
            justify-content: flex-start !important;
            text-align: left !important;
          }
          [data-testid="banner-success"] * {
            font-size: 16px !important;
          }
          [data-testid="banner-success"] h2 {
            font-size: 20px !important;
          }

          ._inline_1q1d2_47 ._formContainer_1q1d2_30{
              width:100%!important;
              max-width:1000px!important;
          }
          ._inline_1q1d2_47 {
              justify-items: unset!important;
              align-content: unset!important;
          }
          #form-container-ref input._formInputField_nag3b_7{
                  // height: var(--input-height, 5rem);
                  min-height: unset!important;
                  // padding: var(--input-padding-block, .8rem) var(--input-padding-inline, 1.6rem)!important;
                  line-height: var(--input-line-height, var(--font-paragraph--line-height, 1.6))!important;
                  box-shadow: inset 0 0 0 var(--input-border-width) rgb(var(--color-input-text)) !important;
                  border: 0 var(--input-border-style, solid) var(--input-border-color, currentcolor)!important;
                  border-radius: var(--input-border-radius, 0)!important;
                  background-color: var(--color-input-background)!important;
                  color: rgb(var(--color-input-text))!important;
                  transition: all var(--animation-duration--medium) var(--animation-easing)!important;
                  transition-property: color, background-color, box-shadow!important;
                  font-size: var(--font-size--paragraph)!important;
                  box-sizing: border-box !important;
          }
          ._formFieldContainer_1mxsl_5:focus-within ._formInputFieldLabel_1mxsl_38{
              transform: unset!important;
          }
          ._formFieldContainer_1mxsl_5 ._inputFilled_1mxsl_74{
              transform: unset!important;
              display:none!important;
          }
          label._formInputFieldLabel_1mxsl_38{
              color:#888888!important;
          }
          ._formFieldContainer_1mxsl_5:has([name="custom#observaciones"]){
              grid-column: 1 / -1;
          }
          #form-container-ref form > div:has([for="custom#adjuntar_receta-field"]){
              grid-column: 1 / -1;
              position:relative;
          }
          #form-container-ref ._formFieldContainer_1mxsl_5:has(textarea)::before{
              background-color:transparent!important;
          }
          #form-container-ref ._formFieldContainer_1mxsl_5 textarea,
          #form-container-ref form > div:has([for="custom#adjuntar_receta-field"]){
              height: 135px;
              border-radius: 20px;
              // padding: var(--input-padding-block, .8rem) var(--input-padding-inline, 1.6rem)!important;
              line-height: var(--input-line-height, var(--font-paragraph--line-height, 1.6))!important;
              box-shadow: inset 0 0 0 var(--input-border-width) rgb(var(--color-input-text)) !important;
              border: 0 var(--input-border-style, solid) var(--input-border-color, currentcolor)!important;
              background-color: var(--color-input-background)!important;
              color: rgb(var(--color-input-text))!important;
              transition: all var(--animation-duration--medium) var(--animation-easing)!important;
              transition-property: color, background-color, box-shadow!important;
              font-size: var(--font-size--paragraph)!important;
              box-sizing: border-box !important;
          }
          #form-container-ref form > div:has([for="custom#adjuntar_receta-field"]) > div{
            position: absolute;
            width: auto;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            background-color: transparent;
            border: none;
                }
          #form-container-ref form > div:has([for="custom#adjuntar_receta-field"]) ._formFileInputButton_k0hif_37{
              font-size: 0px !important;
              height: 36px;
              width: 36px;
              background-image: url(/cdn/shop/files/image_upload.webp?v=1782982717);
              background-position: center;
              background-size: contain;
              background-color: transparent;
              padding: 0px;
              box-sizing: border-box;
          }
          #form-container-ref form > div:has([for="custom#adjuntar_receta-field"]) label[for="custom#adjuntar_receta-field"]{
              align-items:center;
              margin: 0px;
          }
          #form-container-ref form > div:has([for="custom#adjuntar_receta-field"]) ._textBody_2aowh_10{
              position: absolute;
              left: var(--form-field-padding);
              top: var(--input-label-top);
              color: #888888;
          }
          #form-container-ref ._formFileInputContent_k0hif_26 > span{
              font-size: 14px !important;
              color: #0f235a;
          }
          #form-container-ref ._formFileInputContent_k0hif_26 svg{
              fill:#0f235a!important;
          }
          #form-container-ref form > [name="custom#forma_de_envo"]{
              grid-column: 1 / -1;
              padding: 25px var(--input-padding-inline, 1.6rem) !important;
              padding-top: 35px !important;
              background-color: #f3f2f3;
              border-radius: 20px;
              box-sizing: border-box;
              min-inline-size: unset;
              margin: 0px !important;
              height: 100%;
              width: 100%;
              display: block;
              top: -15px;
              position: relative;
          }
          #form-container-ref ._radioFieldSet_nw6va_1 ._textBody_2aowh_10._radioLegend_nw6va_18{
              position: relative!important;
              top: 35px!important;
              padding-bottom: 15px !important;
              color: #888888!important;
              cursor:pointer;
          }
          #form-container-ref ._radioField_nw6va_1 ._textBody_2aowh_10{
              font-size: 12px !important;
              line-height: 1.3;
              color: #888 !important;
              display: block;
          }
          #form-container-ref ._radioInput_nw6va_31,
          #form-container-ref ._checkboxInput_1hja3_38{
              accent-color:#0f235a!important;
              margin-top: 1px;
          }
          #form-container-ref ._radioField_nw6va_1 {
              gap: 5px;
              align-items: flex-start;
          }
          ._checkboxFieldSet_1hja3_3{
              grid-column: 1 / -1;
          }
          button[type="submit"]{
              grid-column: 1 / -1;
          }
          #form-container-ref ._checkboxFieldSet_1hja3_3 ._textBody_2aowh_10._checkboxLegend_1hja3_20{
              display:none;
          }
          ._checkboxFieldSet_1hja3_3 {
              border: none;
              padding: 0;
              // margin-top: -10px;
          }
          #form-container-ref ._checkboxField_1hja3_3 {
              gap: 4px;
              align-items: flex-start;
          }
          #form-container-ref ._checkboxFieldSet_1hja3_3 ._textBody_2aowh_10{
              font-size: 12px !important;
              line-height: 1.3;
              color: #888;
              cursor:pointer;
              display: flex;
              gap: 20px;
          }
          #form-container-ref ._checkboxFieldSet_1hja3_3 ._textBody_2aowh_10:after{
              content:${JSON.stringify(requiredFieldsLabel)};
          }
          #form-container-ref ._formError_1mxsl_21,
          #form-container-ref ._error_1o4ef_1{
              font-size: 12px !important;
              margin-top: 5px;
          }
          #form-container-ref button[type="submit"]{
              grid-column: 1 / -1;
              background-color:rgb(var(--color-primary-button-background));
              border:none;
              color: #ffffff;
              height: min(var(--button-height, 5rem), 4rem);
              display: inline-flex;
              align-items: center;
              justify-content: center;
              width: var(--button-width, auto);
              padding: var(--button-padding-block, 1rem) var(--button-padding-inline, 2.4rem);
              padding-inline: 35px;
              line-height: var(--button-line-height, var(--font-paragraph--line-height, 1.6));
              border-radius: var(--button-corner-radius, 0);
              transition: background-color, color, border-color, opacity, transform var(--animation-duration--medium);
              position: relative;
              z-index: 0;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              text-decoration: none;
              font-size: 12px !important;
              cursor: pointer;
              font-family: var(--font-button--family) !important;
              font-weight: var(--font-button--weight) !important;
              font-style: var(--font-button--style) !important;
              letter-spacing: var(--font-button--letter-spacing);
              text-transform: uppercase;
              box-shadow: unset;
              max-width: 125px;
              filter: unset !important;
              margin-top:20px;
              transition:0.3s;
          }
          #form-container-ref button[type="submit"]:hover {
            background-color: rgb(var(--color-secondary-button-background));
          }

          #form-container-ref form > fieldset[name="custom#user_type"],
          #form-container-ref form > fieldset[name="custom#soy_farmacutico_options"]{
            grid-column: 1 / -1;
            margin-bottom:25px;
          }
          #form-container-ref form > fieldset[name="custom#user_type"] > legend,
          #form-container-ref form > fieldset[name="custom#soy_farmacutico_options"] > legend{
            display:none!important;
          }
          #form-container-ref form > fieldset[name="custom#user_type"] input[type="radio"]{
            position: absolute;
            opacity: 0;
            z-index: -1;
          }
          #form-container-ref form > fieldset[name="custom#user_type"] label{
            background-color: transparent;
            border: solid 1px rgb(var(--color-primary-button-background));
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: var(--button-width, auto);
            padding: var(--button-padding-block, 1rem) var(--button-padding-inline, 2.4rem);
            padding-inline: 25px;
            line-height: var(--button-line-height, var(--font-paragraph--line-height, 1.6));
            border-radius: var(--button-corner-radius, 0);
            position: relative;
            z-index: 0;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-decoration: none;
            font-size: 12px !important;
            cursor: pointer;
            font-family: var(--font-button--family) !important;
            font-weight: var(--font-button--weight) !important;
            font-style: var(--font-button--style) !important;
            letter-spacing: var(--font-button--letter-spacing);
            text-transform: uppercase;
            box-shadow: unset;
            filter: unset !important;
            transition: 0.3s;
          }
          #form-container-ref form > fieldset[name="custom#user_type"] label[for="custom#user_type-Profesional"] span._textBody_2aowh_10:after{
            content: '';
            display: block;
            width: 10px;
            height: 10px;
            background-image: url(https://cdn.shopify.com/s/files/1/1016/7409/0825/files/Vector_1.png?v=1784310638);
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
          }
          #form-container-ref form > fieldset[name="custom#user_type"] label[for="custom#user_type-Profesional"]:has(input[type="radio"]:checked) span._textBody_2aowh_10:after{
            background-image: url(https://cdn.shopify.com/s/files/1/1016/7409/0825/files/Vector.png?v=1784310145);
          }
          #form-container-ref form > fieldset[name="custom#user_type"] label[for="custom#user_type-Profesional"] span._textBody_2aowh_10{
            display:flex;
            gap:8px;
            align-items:center;
          }
          #form-container-ref form > fieldset[name="custom#user_type"] label span._textBody_2aowh_10{
            color: rgb(var(--color-primary-button-background))!important;
            font-size:16px!important;
            transition:0.3s;
          }
          #form-container-ref form > fieldset[name="custom#user_type"] label:has(input[type="radio"]:checked){
            background-color:rgb(var(--color-primary-button-background));
          }
          #form-container-ref form > fieldset[name="custom#user_type"] label:has(input[type="radio"]:checked) span._textBody_2aowh_10{
            color:#ffffff!important;
          }
          #form-container-ref form > fieldset[name="custom#user_type"] ._verticalLayout_nw6va_6{
            display: flex;
            flex-direction: row;
            gap: 8px;
          }
          #form-container-ref form > fieldset[name="custom#soy_farmacutico_options"]{
            // display:none;
            padding-left:10px;
            margin-top:-20px;
            margin-bottom: 15px;
            margin-left: 180px;
          }
          #form-container-ref form:has(input[type="radio"][value="Profesional"]:checked) > fieldset[name="custom#soy_farmacutico_options"]{
            display:block;
          }
          #form-container-ref form > fieldset[name="custom#soy_farmacutico_options"] label span._textBody_2aowh_10{
            font-size: 16px !important;
          }
          #form-container-ref form > fieldset[name="custom#soy_farmacutico_options"] label:has(input[type="radio"]:checked) span._textBody_2aowh_10{
            color:rgb(var(--color-primary-button-background))!important;
          }
          #form-container-ref form > fieldset[name="custom#soy_farmacutico_options"] ._radioField_nw6va_1{
            align-items:center;
          }
          #form-container-ref form > fieldset[name="custom#soy_farmacutico_options"] ._radioField_nw6va_1{
            margin-top:0px;
            cursor:pointer;
          }

          @media(max-width:767px){
              #form-container-ref form{
                  grid-template-columns: 1fr !important;
              }
              #form-container-ref ._checkboxFieldSet_1hja3_3 ._textBody_2aowh_10 {
                  gap: 2px;
                  flex-direction: column;
              }
              #form-container-ref ._checkboxField_1hja3_3 {
                  gap: 8px;
              }
              #form-container-ref ._formFileInputContent_k0hif_26 > span{
                  font-size: 12px !important;
              }
              #form-container-ref form > fieldset[name="custom#user_type"] label span._textBody_2aowh_10,
              #form-container-ref form > fieldset[name="custom#soy_farmacutico_options"] label span._textBody_2aowh_10{
                font-size: 14px !important;
              }
              #form-container-ref form > fieldset[name="custom#user_type"] label{
                padding-left:15px;
                padding-right:15px;
              }
          }

          
          #form-container-ref form{
              --col-gap: 10px;
              --row-gap: 8px;

              display: flex !important;
              flex-direction: row !important;
              flex-wrap: wrap !important;
              gap: var(--row-gap) var(--col-gap) !important;
          }
          #form-container-ref form > *{
            width: calc(50% - var(--col-gap)) !important;
            // padding: calc(var(--row-gap) / 2) calc(var(--col-gap) / 2) !important;
          }
          #form-container-ref form > *:has([id="custom#cdigo_postal"]),
          #form-container-ref form > *:has([id="custom#poblacin"]){
            width: calc(25% - var(--col-gap)) !important;
          }
          #form-container-ref form > *:has([name="custom#observaciones"]),
          #form-container-ref form > *:has([id="custom#adjuntar_receta-field"]),
          #form-container-ref form > *:has([name="custom#he_ledo_y_acepto_la_poltica_de_privacidad"]){
            width: 100% !important;
          } 
          #form-container-ref form > *:has([name="custom#he_ledo_y_acepto_la_poltica_de_privacidad"]){
            margin-top: 10px;
          }
          #form-container-ref form > *:has([name="custom#he_ledo_y_acepto_la_poltica_de_privacidad"]) *{
            font-size: 12px !important;
            line-height: 1.3;
            color: #888;
          }
          #form-container-ref .xalabarder-professional-download {
            width: 100% !important;
            margin: 28px 0 8px;
            color: rgb(var(--color-primary-button-background)) !important;
            font-size: 16px !important;
            line-height: 1.125 !important;
          }
          #form-container-ref .xalabarder-professional-download a {
            color: inherit !important;
            font-size: inherit !important;
            line-height: inherit !important;
            text-decoration: underline;
            text-underline-offset: 2px;
          }
          #form-container-ref form input[type="text"],
          #form-container-ref form input[type="number"] {
            height: 45px !important;
            padding: 0px 25px !important;
          }
          #form-container-ref form textarea {
            padding: 15px 25px !important;
          }
          #form-container-ref label {
            top: 15px !important;
            left: 25px !important;
          }
          #form-container-ref form > *:has(textarea) label {
            top: 20px !important;
          }
          #form-container-ref button[type="submit"] {
            min-width: 159px !important;
            width: fit-content !important;
            max-width: 100% !important
          }
        `;

        form.shadowRoot.appendChild(style);
        const localizeFileLabels = () => {
          form.shadowRoot
            .querySelectorAll('[class*="_formFileInputContent_"] > span')
            .forEach((label) => {
              if (label.textContent !== addFileLabel) {
                label.textContent = addFileLabel;
              }
            });
        };

        localizeFileLabels();

        const fileLabelObserver = new MutationObserver(localizeFileLabels);
        fileLabelObserver.observe(form.shadowRoot, {
          childList: true,
          subtree: true,
        });
      }
    });
  }, 200);
}

waitForShopifyForm();

(function () {
  function fixErrors() {
    const embeds = document.querySelectorAll("shopify-forms-embed");

    embeds.forEach((embed) => {
      if (!embed || !embed.shadowRoot) return;

      const shadow = embed.shadowRoot;
      const form = shadow.querySelector("form");
      if (!form) return;

      form.querySelectorAll("._formFieldContainer_1mxsl_5").forEach((field) => {
        const error = field.nextElementSibling;

        if (error && error.tagName === "OUTPUT" && !field.contains(error)) {
          field.appendChild(error);
        }
      });
    });
  }

  const wait = setInterval(() => {
    const embeds = document.querySelectorAll("shopify-forms-embed");

    embeds.forEach((embed) => {
      if (embed?.shadowRoot) {
        clearInterval(wait);

        fixErrors();

        const observer = new MutationObserver(fixErrors);

        observer.observe(embed.shadowRoot, {
          childList: true,
          subtree: true,
        });
      }
    });
  }, 100);
})();

(function () {
  /* Fix buggy scroll on forms - Start */
  let restoreTimeout;

  function getFormIframes() {
    return document.querySelectorAll(
      ".profesional-form shopify-forms-embed, .particular-form shopify-forms-embed",
    );
  }

  function handleWheel() {
    getFormIframes().forEach((f) => {
      f.style.pointerEvents = "none";
    });
    clearTimeout(restoreTimeout);
    restoreTimeout = setTimeout(() => {
      getFormIframes().forEach((f) => {
        f.style.pointerEvents = "";
      });
    }, 200); // restore ~200ms after the last wheel tick
  }

  window.addEventListener("wheel", handleWheel, { passive: true });
  /* Fix buggy scroll on forms - End */

  function getShadowRoots() {
    let shadowRoots = [];

    const embeds = document.querySelectorAll("shopify-forms-embed");

    embeds.forEach((embed) => {
      if (embed && embed.shadowRoot) {
        shadowRoots.push(embed.shadowRoot);
      }
    });

    return shadowRoots;
  }

  function checkRadio(name, value) {
    /* IN DOCUMENT */
    const radios = document.querySelectorAll(`input[name="${name}"]`);

    radios.forEach((radio) => {
      if (radio.value === value) {
        const label = document.querySelector(`label[for="${radio.id}"]`);

        if (label) {
          label.click();
        } else {
          radio.checked = true;
          radio.dispatchEvent(new Event("input", { bubbles: true }));
          radio.dispatchEvent(new Event("change", { bubbles: true }));
          radio.click();
        }
      }
    });

    /* IN FORM SHADOW ROOT */
    const shadows = getShadowRoots();

    if (shadows.length === 0) return;

    shadows.forEach((shadow) => {
      const radios = shadow.querySelectorAll(`input[name="${name}"]`);

      radios.forEach((radio) => {
        if (radio.value === value) {
          const label = shadow.querySelector(`label[for="${radio.id}"]`);

          if (label) {
            label.click();
          } else {
            radio.checked = true;
            radio.dispatchEvent(new Event("input", { bubbles: true }));
            radio.dispatchEvent(new Event("change", { bubbles: true }));
            radio.click();
          }
        }
      });
    });
  }

  function resetProfessionalOptions() {
    const shadows = getShadowRoots();

    if (shadows.length === 0) return;

    shadows.forEach((shadow) => {
      const radios = shadow.querySelectorAll(
        'input[name="custom#soy_farmacutico_options"]',
      );

      radios.forEach((radio) => {
        radio.checked = false;
        radio.dispatchEvent(new Event("input", { bubbles: true }));
        radio.dispatchEvent(new Event("change", { bubbles: true }));
      });

      document
        .querySelectorAll(".formula-professional-button")
        .forEach((button) => {
          button.classList.remove("button-form-active");
        });
    });
  }

  function initButtons(selector, radioName) {
    // initButtons(".formula-user-button", "custom#user_type");

    const buttons = document.querySelectorAll(selector);

    buttons.forEach((button) => {
      button.addEventListener("click", function (e) {
        e.preventDefault();

        buttons.forEach((item) => {
          item.classList.remove("button-form-active");
        });

        button.classList.add("button-form-active");

        checkRadio(radioName, button.dataset.value);

        if (
          radioName === "custom#user_type" &&
          button.dataset.value === "Profesional"
        ) {
          resetProfessionalOptions();
        }

        const target = button.getAttribute("href");

        if (target && target.startsWith("#")) {
          const element = document.querySelector(target);

          if (element) {
            element.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        }
      });
    });
  }

  function decodeHtmlEntities(str) {
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
  }

  const wait = setInterval(() => {
    const shadows = getShadowRoots();

    if (shadows.length === 0) return;

    shadows.forEach((shadow) => {
      // if (!shadow.querySelector('input[name="custom#user_type"]')) return;

      clearInterval(wait);

      initButtons(".formula-user-button", "custom#user_type");

      initButtons(
        ".formula-professional-button",
        "custom#soy_farmacutico_options",
      );

      const privacies = shadow.querySelectorAll(
        '[name="custom#he_ledo_y_acepto_la_poltica_de_privacidad"] label span',
      );
      console.log(privacies);
      privacies.forEach((privacy) => {
        privacy.innerHTML =
          "<span>" + decodeHtmlEntities(privacy.innerHTML) + "</span>";
      });
    });
  }, 200);

  const waitFormSuccess = setInterval(() => {
    const shadows = getShadowRoots();

    if (shadows.length === 0) return;

    shadows.forEach((shadow) => {
      // if (!shadow.querySelector('input[name="custom#user_type"]')) return;

      if (shadow.querySelector('[data-testid="banner-success"]')) {
        document.querySelector(".form-header").style.display = "none";
        clearInterval(waitFormSuccess);
      }
    });
  }, 200);
})();

(function () {
  function getProfessionalDownloadSource() {
    return document.querySelector(
      '.profesional-form [class*="__professional_download_notice"]',
    );
  }

  function addProfessionalDownload(embed, source) {
    const shadow = embed.shadowRoot;
    const form = shadow?.querySelector("form");

    if (!form) return;

    let notice = form.querySelector(".xalabarder-professional-download");

    if (!source?.textContent.trim()) {
      notice?.remove();
      return;
    }

    const submitButton = form.querySelector('button[type="submit"]');
    if (!submitButton) return;

    const submitRow =
      submitButton.parentElement === form
        ? submitButton
        : Array.from(form.children).find((child) =>
            child.contains(submitButton),
          ) || submitButton;

    if (!notice) {
      notice = document.createElement("div");
      notice.className = "xalabarder-professional-download";
      submitRow.before(notice);
    }

    if (notice.innerHTML !== source.innerHTML) {
      notice.innerHTML = source.innerHTML;
    }
  }

  function syncProfessionalDownloads() {
    const source = getProfessionalDownloadSource();
    const professionalEmbeds = document.querySelectorAll(
      ".profesional-form shopify-forms-embed",
    );

    professionalEmbeds.forEach((embed) => {
      if (!embed.shadowRoot) return;

      addProfessionalDownload(embed, source);

      if (!embed.dataset.downloadNoticeObserved) {
        embed.dataset.downloadNoticeObserved = "true";
        const observer = new MutationObserver(() => {
          addProfessionalDownload(embed, getProfessionalDownloadSource());
        });

        observer.observe(embed.shadowRoot, {
          childList: true,
          subtree: true,
        });
      }
    });

    return professionalEmbeds.length > 0;
  }

  const wait = setInterval(() => {
    if (syncProfessionalDownloads()) clearInterval(wait);
  }, 200);

  document.addEventListener("shopify:section:load", syncProfessionalDownloads);
  document.addEventListener("shopify:block:select", syncProfessionalDownloads);
})();
